import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=7a1e992a&scoped=true"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js"
import style0 from "./cancellationPolicy.vue?vue&type=style&index=0&id=7a1e992a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1e992a",
  null
  
)

export default component.exports